var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const EDGE_LENGTH = { large: 48, default: 24, small: 12 };
export const ExternalIcon = React.forwardRef((props, ref) => {
    const { variant = 'default', svgSelector = '#main', title, url } = props, rest = __rest(props, ["variant", "svgSelector", "title", "url"]);
    const ariaHidden = !props.alt;
    const edgeLength = EDGE_LENGTH[variant];
    return (React.createElement("svg", Object.assign({ className: props.className, "aria-hidden": ariaHidden, role: ariaHidden ? undefined : 'img', "aria-label": props.alt || undefined, ref: ref, width: edgeLength, height: edgeLength, viewBox: `0 0 ${edgeLength} ${edgeLength}`, fill: "currentColor" }, rest),
        title && React.createElement("title", null, title),
        React.createElement("use", { href: `${url}${svgSelector}` })));
});
ExternalIcon.displayName = 'ExternalIcon';
